import React from "react";
import styled from "styled-components";
import {
  Form,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Button,
  Select,
  Switch,
  Slider
} from "antd";
import { UserConsumer } from "../../App";
import AssessmentScoreForm from "./_form_partials/_AssessmentScoreForm";

const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const FormWrapper = styled.div``;

const ErrorLabel = styled.label`
  color: red;
`;

class AddDailyReportForm extends React.PureComponent {
  handleSubmit = async e => {
    const { student, studentSubject } = this.props;

    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const formData = Object.assign({}, values, {
          assessment_score: {},
          classroom_observation_score: {}
        });
        // Add the studentId property
        formData.studentId = this.props.student._id;

        Object.keys(values).map(key => {
          // if the key contains assessment, group or observation which are GROUP KEY IDENTIFIERS set the correct groupKey
          let groupKey;
          if (key.includes("assessment")) {
            groupKey = "assessment_score";
          } else if (key.includes("observation")) {
            groupKey = "classroom_observation_score";
          } else if (key.includes("groupEval")) {
            groupKey = "group_evaluation_score";
          } else if (key.includes("groupMemberEval")) {
            groupKey = "group_member_evaluation_score";
          } else {
            return;
          }

          // STRIP out the groupkey identifier
          const fieldNameWithoutGroupKeyIdentifier = `${key.substr(
            key.indexOf("_") + 1
          )}`;

          formData[groupKey] = {
            ...formData[groupKey],
            // we rather clumsily transform the boolean values into 0||1
            [fieldNameWithoutGroupKeyIdentifier]:
              typeof values[key] == "boolean"
                ? this._booleanToScore(values[key])
                : values[key]
          };
          delete formData[key];
        });

        // Once we have all our data, final step is to take the group scores and nest them in the formData object to reflect the grpahQL schema
        const {
          group_evaluation_score,
          group_member_evaluation_score
        } = formData;


        const {agreed_on_plan, completed_assignment, participated, productive, respectful } = group_evaluation_score;
        if( agreed_on_plan === 0 && completed_assignment === 0 && participated === 0 && productive === 0 && respectful === 0){
          group_evaluation_score.total_score = 0;
        }

        const {
          accepted_feedback, assisted_in_preparation, expressed_ideas,
        gave_feedback, listened_to_ideas, performed_assigned_roles,
        understood_activity_purpose, willing_to_compormise,
        } = group_member_evaluation_score;
        if(
          accepted_feedback === 0 && group_member_evaluation_score.answered_questions === 0 && assisted_in_preparation === 0 && expressed_ideas === 0 &&
        gave_feedback === 0 && listened_to_ideas === 0 && group_member_evaluation_score.participated === 0 && performed_assigned_roles === 0 &&
        understood_activity_purpose === 0 && willing_to_compormise === 0
        ){
          group_member_evaluation_score.total_score = 0;
        }

        formData.group_observation_score = {
          group_evaluation_score,
          group_member_evaluation_score,
          total_score:
          group_evaluation_score.total_score +
          group_member_evaluation_score.total_score
        };
        
        delete formData.group_evaluation_score;
        delete formData.group_member_evaluation_score;


        const {
          answered_questions, asked_questions, attentive, present
        } = formData.classroom_observation_score
        
        if (answered_questions === 0 && asked_questions === 0 && attentive === 0 && formData.classroom_observation_score.participated === 0 && present === 0) {
          formData.classroom_observation_score.total_score = 0
        }
        

        console.log(formData.classroom_observation_score,  'classroom><');
        // Finally add the remaining fields for the daily report
        const total_score =
          formData.assessment_score.total_score +
          formData.classroom_observation_score.total_score +
          formData.group_observation_score.total_score;

        const percentage_score = (total_score / 100) * 100;
        const score_group = this._getScoreGroup(percentage_score);

        formData.total_score = total_score;
        formData.percentage_score = percentage_score;
        formData.score_group = score_group;
        formData.subjectId = studentSubject && studentSubject._id;
        formData.classroomId = student && student.classroom._id;

        console.log(formData, 'data to eb sent');
        this.props.onSubmit(formData);
      }
    });
  };

  _booleanToScore = bool => (Boolean(bool) ? 1 : 0);

  _getScoreGroup = percentage => {
    if (percentage < 25) return "SCORE_GROUP_0";
    if (percentage < 60) return "SCORE_GROUP_1";
    if (percentage < 90) return "SCORE_GROUP_2";
    if (percentage <= 100) return "SCORE_GROUP_3";
  };

  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { student, lessons, studentSubject, error } = this.props;

    //TODO: the subject and lesson select field should be related
    return (
      <UserConsumer>
        {user => (
          <FormWrapper>
            <h3>
              Daily Report for {`${student.firstName} ${student.lastName}`}
            </h3>
            <p>
              Subject:{" "}
              {`${studentSubject ? studentSubject.name : "loading..."}`}
            </p>
            <p>Classroom: {`${student.classroom.name}`}</p>
            <Form onSubmit={e => this.handleSubmit(e)}>
              <FormItem label="Lesson">
                {getFieldDecorator("lessonId", {
                  rules: [
                    {
                      required: true,
                      message: "Please select a lesson"
                    }
                  ]
                })(
                  <Select defaultActiveFirstOption>
                    {lessons &&
                      lessons.map(lesson => (
                        <Option key={lesson._id} value={lesson._id}>
                          {lesson.name}
                        </Option>
                      ))}
                  </Select>
                )}
              </FormItem>

              <FormItem label="Date">
                {getFieldDecorator("date", {
                  rules: [
                    {
                      required: true,
                      message: "Please pick a date"
                    }
                  ]
                })(<DatePicker />)}
              </FormItem>

              <FormItem label="Term Week">
                {getFieldDecorator("week", {
                  rules: [
                    {
                      required: true,
                      message: "Please add the week"
                    }
                  ]
                })(<InputNumber min={1} max={18} />)}
              </FormItem>

              {/* NOW WE HAVE VARIOUS SECTIONS THE MAKE UP THE FORM */}

              <Divider orientation="left">Assessment Score</Divider>
              <FormItem label="Task 1 Score (max. 15 marks)">
                {getFieldDecorator("assessment_task1_score", {
                  rules: [
                    {
                      required: true,
                      message: "Please add score"
                    }
                  ]
                })(
                  <InputNumber
                    initialValue={0}
                    onChange={this._assessmentInputChange(
                      "assessment_task1_score"
                    )}
                    min={0}
                    max={15}
                  />
                )}
              </FormItem>
              <FormItem label="Task 2 Score (max. 15 marks)">
                {getFieldDecorator("assessment_task2_score", {
                  rules: [
                    {
                      required: true,
                      message: "Please add score"
                    }
                  ]
                })(
                  <InputNumber
                    initialValue={0}
                    onChange={this._assessmentInputChange(
                      "assessment_task2_score"
                    )}
                    min={0}
                    max={15}
                  />
                )}
              </FormItem>
              <FormItem label="Task 3 Score (max. 10 marks)">
                {getFieldDecorator("assessment_task3_score", {
                  rules: [
                    {
                      required: true,
                      message: "Please add score"
                    }
                  ]
                })(
                  <InputNumber
                    initialValue={0}
                    onChange={this._assessmentInputChange(
                      "assessment_task3_score"
                    )}
                    min={0}
                    max={10}
                  />
                )}
              </FormItem>
              <FormItem label="Homework Score (max. 10 marks)">
                {getFieldDecorator("assessment_homework_score", {
                  rules: [
                    {
                      required: true,
                      message: "Please add score"
                    }
                  ]
                })(
                  <InputNumber
                    initialValue={0}
                    onChange={this._assessmentInputChange(
                      "assessment_homework_score"
                    )}
                    min={0}
                    max={10}
                  />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the task scores and homework scores"
                label="Total Score Achieved (Total of 50 marks)"
              >
                {getFieldDecorator("assessment_total_score")(
                  <InputNumber disabled min={0} max={50} />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the task scores and homework scores"
                label="Percentage Score (%)"
              >
                {getFieldDecorator("assessment_percentage_score")(
                  <InputNumber disabled min={0} max={100} />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the task scores and homework scores"
                label="Score Group"
              >
                {getFieldDecorator("assessment_score_group")(
                  <Input disabled />
                )}
              </FormItem>

              <Divider orientation="left">Classroom Observation Score</Divider>

              <FormItem label="Present In Class">
                {getFieldDecorator("observation_present", { initialValue: 0 })(
                  <Switch
                    onChange={this._classroomObservationInputChange(
                      "observation_present"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="Listened Attentively">
                {getFieldDecorator("observation_attentive", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._classroomObservationInputChange(
                      "observation_attentive"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="Participated during class activity">
                {getFieldDecorator("observation_participated", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._classroomObservationInputChange(
                      "observation_participated"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="Asked questions during the lesson">
                {getFieldDecorator("observation_asked_questions", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._classroomObservationInputChange(
                      "observation_asked_questions"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="Answered questions during the lesson">
                {getFieldDecorator("observation_answered_questions", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._classroomObservationInputChange(
                      "observation_answered_questions"
                    )}
                  />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the preceeding 5 questions"
                label="Total Score Achieved (Total of 5 marks)"
              >
                {getFieldDecorator("observation_total_score")(
                  <InputNumber disabled min={0} max={5} />
                )}
              </FormItem>

              <Divider orientation="left">Group Evaluation Score</Divider>
              <FormItem label="Group Name">
                {getFieldDecorator("groupEval_group_name",{
                  rules: [
                    {
                      required: true,
                      message: "Please add a group name"
                    }
                  ]
                })(<Input />)}
              </FormItem>
              <FormItem label="Group Activity">
                {getFieldDecorator("groupEval_activity", {
                  rules: [
                    {
                      required: true,
                      message: "Please add a group activity"
                    }
                  ]
                })(<Input />)}
              </FormItem>

              <FormItem label="The group agreed on a plan">
                {getFieldDecorator("groupEval_agreed_on_plan", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._groupEvalInputChange(
                      "groupEval_agreed_on_plan"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="All group members participated">
                {getFieldDecorator("groupEval_participated", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._groupEvalInputChange(
                      "groupEval_participated"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="The group used its time productively">
                {getFieldDecorator("groupEval_productive", { initialValue: 0 })(
                  <Switch
                    onChange={this._groupEvalInputChange(
                      "groupEval_productive"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="The group respected the opinions of all members">
                {getFieldDecorator("groupEval_respectful", { initialValue: 0 })(
                  <Switch
                    onChange={this._groupEvalInputChange(
                      "groupEval_respectful"
                    )}
                  />
                )}
              </FormItem>
              <FormItem label="The group successfully completed the assignment">
                {getFieldDecorator("groupEval_completed_assignment", {
                  initialValue: 0
                })(
                  <Switch
                    onChange={this._groupEvalInputChange(
                      "groupEval_completed_assignment"
                    )}
                  />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the preceeding 5 questions"
                label="Total Score Achieved (Total of 5 marks)"
              >
                {getFieldDecorator("groupEval_total_score")(
                  <InputNumber disabled min={0} max={5} />
                )}
              </FormItem>

              <Divider orientation="left">
                Group Member Evaluation Score
              </Divider>
              <FormItem label="Group Name">
                {getFieldDecorator("groupMemberEval_group_name", {
                  rules: [
                    {
                      required: true,
                      message: "Please add a group name"
                    }
                  ]
                })(<Input />)}
              </FormItem>
              <FormItem label="Group Activity">
                {getFieldDecorator("groupMemberEval_activity", {
                  rules: [
                    {
                      required: true,
                      message: "Please add a group activity"
                    }
                  ]
                })(<Input />)}
              </FormItem>
              <FormItem label="Performed their Assigned roles">
                {getFieldDecorator("groupMemberEval_performed_assigned_roles", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_performed_assigned_roles"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Understood the purpose of the activity">
                {getFieldDecorator(
                  "groupMemberEval_understood_activity_purpose",
                  {
                    initialValue: 0
                  }
                )(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_understood_activity_purpose"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Were able to answer the questions">
                {getFieldDecorator("groupMemberEval_answered_questions", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_answered_questions"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Listened to each others’ ideas">
                {getFieldDecorator("groupMemberEval_listened_to_ideas", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_listened_to_ideas"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Gave feedback to those who contributed ideas">
                {getFieldDecorator("groupMemberEval_gave_feedback", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_gave_feedback"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Assisted in preparing the work">
                {getFieldDecorator("groupMemberEval_assisted_in_preparation", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_assisted_in_preparation"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Expressed their ideas to the group">
                {getFieldDecorator("groupMemberEval_expressed_ideas", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_expressed_ideas"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Were willing to compromise when needed.">
                {getFieldDecorator("groupMemberEval_willing_to_compormise", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_willing_to_compormise"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Took feedback from other">
                {getFieldDecorator("groupMemberEval_accepted_feedback", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_accepted_feedback"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem label="Actively participated in the group">
                {getFieldDecorator("groupMemberEval_participated", {
                  initialValue: 0
                })(
                  <Slider
                    onChange={this._groupMemberEvalInputChange(
                      "groupMemberEval_participated"
                    )}
                    min={0}
                    max={4}
                    marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }}
                  />
                )}
              </FormItem>
              <FormItem
                help="This is calculated automatically from the preceeding 10 questions"
                label="Total Score Achieved (Total of 40 marks)"
              >
                {getFieldDecorator("groupMemberEval_total_score")(
                  <InputNumber disabled min={0} max={40} />
                )}
              </FormItem>
              <ErrorLabel>{error}</ErrorLabel>
              <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                >
                  Create Report
                </Button>
              </FormItem>
            </Form>
          </FormWrapper>
        )}
      </UserConsumer>
    );
  }

  _assessmentInputChange = fieldName => value => {
    // This isn't as tricky as it looks.
    // We take the this.props.form.getFieldsValue() method to fetch all the fields we need to populate the auto-generated assessment score fields. This returns an object. The object is one step behind the most recent changes (probably due to react state change not being syncronous while this callback is) thus we access the most recent change using "fieldName" and "value" and we overshadow the object provided to us from this.props.form.getFieldsValue() with {[fieldName]: value}. We then deconstruct and pull out the individual fields setting defaults for fields that may be undefined. Add the fields together, massage some of the output and then setFieldsValue() for the auto-generated fields

    const {
      assessment_task1_score = 0,
      assessment_task2_score = 0,
      assessment_task3_score = 0,
      assessment_homework_score = 0
    } = Object.assign(
      this.props.form.getFieldsValue([
        "assessment_task1_score",
        "assessment_task2_score",
        "assessment_task3_score",
        "assessment_homework_score"
      ]),
      { [fieldName]: value }
    );

    const assessment_total_score =
      assessment_task1_score +
      assessment_task2_score +
      assessment_task3_score +
      assessment_homework_score;
    const assessment_percentage_score = (assessment_total_score / 50) * 100;
    const assessment_score_group = this._getScoreGroup(
      assessment_percentage_score
    );
    this.props.form.setFieldsValue({
      assessment_total_score,
      assessment_percentage_score,
      assessment_score_group
    });
  };

  _groupMemberEvalInputChange = fieldName => value => {
    const {
      groupMemberEval_performed_assigned_roles = 0,
      groupMemberEval_understood_activity_purpose = 0,
      groupMemberEval_answered_questions = 0,
      groupMemberEval_listened_to_ideas = 0,
      groupMemberEval_gave_feedback = 0,
      groupMemberEval_assisted_in_preparation = 0,
      groupMemberEval_expressed_ideas = 0,
      groupMemberEval_willing_to_compormise = 0,
      groupMemberEval_accepted_feedback = 0,
      groupMemberEval_participated = 0
    } = Object.assign(
      this.props.form.getFieldsValue([
        "groupMemberEval_performed_assigned_roles",
        "groupMemberEval_understood_activity_purpose",
        "groupMemberEval_answered_questions",
        "groupMemberEval_listened_to_ideas",
        "groupMemberEval_gave_feedback",
        "groupMemberEval_assisted_in_preparation",
        "groupMemberEval_expressed_ideas",
        "groupMemberEval_willing_to_compormise",
        "groupMemberEval_accepted_feedback",
        "groupMemberEval_participated"
      ]),
      { [fieldName]: value }
    );

    const groupMemberEval_total_score =
      groupMemberEval_performed_assigned_roles +
      groupMemberEval_understood_activity_purpose +
      groupMemberEval_answered_questions +
      groupMemberEval_listened_to_ideas +
      groupMemberEval_gave_feedback +
      groupMemberEval_assisted_in_preparation +
      groupMemberEval_expressed_ideas +
      groupMemberEval_willing_to_compormise +
      groupMemberEval_accepted_feedback +
      groupMemberEval_participated;

    this.props.form.setFieldsValue({
      groupMemberEval_total_score
    });
  };

  _classroomObservationInputChange = fieldName => value => {
    const {
      observation_present = 0,
      observation_participated = 0,
      observation_attentive = 0,
      observation_asked_questions = 0,
      observation_answered_questions = 0
    } = Object.assign(
      this.props.form.getFieldsValue([
        "observation_present",
        "observation_participated",
        "observation_attentive",
        "observation_asked_questions",
        "observation_answered_questions"
      ]),
      { [fieldName]: value }
    );

    const observation_total_score =
      this._booleanToScore(observation_present) +
      this._booleanToScore(observation_participated) +
      this._booleanToScore(observation_attentive) +
      this._booleanToScore(observation_asked_questions) +
      this._booleanToScore(observation_answered_questions);

    this.props.form.setFieldsValue({
      observation_total_score
    });
  };

  _groupEvalInputChange = fieldName => value => {
    // see _assessmentInputChange below
    const {
      groupEval_agreed_on_plan = 0,
      groupEval_participated = 0,
      groupEval_productive = 0,
      groupEval_respectful = 0,
      groupEval_completed_assignment = 0
    } = Object.assign(
      this.props.form.getFieldsValue([
        "groupEval_agreed_on_plan",
        "groupEval_participated",
        "groupEval_productive",
        "groupEval_respectful",
        "groupEval_completed_assignment"
      ]),
      { [fieldName]: value }
    );

    const groupEval_total_score =
      this._booleanToScore(groupEval_agreed_on_plan) +
      this._booleanToScore(groupEval_participated) +
      this._booleanToScore(groupEval_productive) +
      this._booleanToScore(groupEval_respectful) +
      this._booleanToScore(groupEval_completed_assignment);

    this.props.form.setFieldsValue({
      groupEval_total_score
    });
  };
}

const WrappedAddDailyReportForm = Form.create()(AddDailyReportForm);

export default WrappedAddDailyReportForm;
